import { useTranslation } from "react-i18next";
import { Menu, Moon, Sun } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";
import { pageMetaFor } from "../navigation";
import "./AppHeader.css";

// Top bar of the main column: eyebrow + page title on the left, page-level
// actions (activity menu slot, theme toggle) on the right.
export default function AppHeader({ activeTab, sidebarOpen, onToggleSidebar, children }) {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const { eyebrowKey, titleKey } = pageMetaFor(activeTab);
  const ThemeIcon = theme === "dark" ? Sun : Moon;

  return (
    <header className="app-header">
      <button
        type="button"
        className="app-header-icon-btn app-header-menu"
        aria-label={t("header.openMenu")}
        aria-expanded={Boolean(sidebarOpen)}
        onClick={onToggleSidebar}
      >
        <Menu size={18} aria-hidden="true" />
      </button>
      <div className="app-header-titles">
        <div className="ds-eyebrow">{t(eyebrowKey)}</div>
        <h1 className="app-header-title">{t(titleKey)}</h1>
      </div>
      <div className="app-header-actions">
        {children}
        <button
          type="button"
          className="app-header-icon-btn"
          aria-label={t("theme.toggle")}
          title={t(theme === "dark" ? "theme.light" : "theme.dark")}
          onClick={toggleTheme}
        >
          <ThemeIcon size={16} aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}
